// src/utils/websiteUtils.js
import axios from "axios";
import { config } from "../config";
import { validateEmail, websiteValidation } from "./validation";

export const validateWebsiteData = ({ name, email, website }) => ({
  name: name.length <= 2,
  email: !validateEmail(email),
  website: !websiteValidation(website),
});

export const scrapeWebsite = async (userWebsiteData) => {
  const response = await axios.post(
    `${config.BASE_API_URL}/api/v1/clients/scrape-website`,
    {
      name: userWebsiteData.name,
      email: userWebsiteData.email,
      website: userWebsiteData.website,
      phone: userWebsiteData.phone,
    }
  );
  return response.data;
};
